export default __webpack_public_path__ + "static/media/gallery01.a4d0fc1d.jpg";